export default "__VITE_ASSET__DQMAXnYF__"